// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Addition_wrapper__1LoGQ","title":"Addition_title__2jPIN","content":"Addition_content__2pkVa"};